export function formatNumber(value) {
  const stringValue = String(value)
  const numberValue = stringValue.replace(/[^\d.]/g, "")
  return Number(numberValue).toLocaleString("es-PE")
}
